<template>
  <div class="chart-box">
    <div id="myChart" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    usage: {
      type: Array,
      default: function () {
        return [];
      },
    },
    xaxis: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      xAxisData: [], // x轴
      seriesData: [], // 对应X、Y轴value值
    };
  },
  computed: {
    //  数据处理
    echartsData() {
      return { xAxisData: this.xaxis, seriesData: this.usage };
    },
    // Echarts实例
    myChart() {
      return echarts.init(document.getElementById("myChart"));
    },
    option() {
      return {
        grid: { x: 40, y: 35, x2: 15, y2: 70 },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: this.appData.subs1color,
              width: 40,
              type: "solid",
            },
          },
          backgroundColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          padding: 0,
          extraCssText: "box-shadow: none",
          formatter: (params) => {
            return this.tipEvent(params[0]);
          },
        },
        xAxis: {
          type: "category",
          data: this.echartsData.xAxisData,
          axisLine: {
            lineStyle: {
              color: "#EAEAEA",
            },
          },
          axisLabel: {
            color: "#848992",
            rotate: 40,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          name: "流量(GB)",
          nameTextStyle: {
            color: "#333333",
            align: "center",
          },
          nameGap: 20,
          axisLabel: {
            margin: 4,
            color: "#848992",
            formatter: function (value, index) {
              if (value >= 1000 && value < 10000) {
                return value / 1000 + "k";
              }
              if (value >= 10000) {
                return value / 10000 + "M";
              }
              return value;
            },
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: ["#EAEAEA"],
            },
          },
        },
        series: [
          {
            data: this.echartsData.seriesData,
            type: "bar",
            barWidth: 20,
            itemStyle: {
              borderRadius: 15,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: this.appData.subs5color },
                { offset: 1, color: this.appData.merThemeColor },
              ]),
            },
            emphasis: {
              disabled: true,
            },
          },
        ],
      };
    },
  },
  mounted() {},
  watch: {
    usage() {
      this.init();
    },
  },
  methods: {
    init() {
      this.myChart.clear();
      this.myChart.setOption(this.option);
    },
    tipEvent(rowData) {
      return `<div class="echarhs-tip-box">
                        <div class="tip-name">${rowData.name}</div>
                        <div class="tip-text">   
                            <span class="icon"></span> 
                            <span class="name">流量使用：${rowData.value}GB</span>
                        </div>
                    </div>`;
    },
  },
};
</script>
<style lang="less" scoped>
.chart-box {
  // padding: 0 30px;
  height: 620px;
  /deep/ .echarhs-tip-box {
    padding: 16px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 8px 8px 20px 0px rgba(194, 194, 194, 0.25);
    .tip-name {
      font-size: 24px;
      color: #848992;
    }
    .tip-text {
      display: flex;
      align-items: center;
      .icon {
        width: 12px;
        height: 12px;
        background: var(--primary-color);
        border-radius: 50%;
        margin-right: 12px;
      }
      .name {
        font-size: 24px;
        color: #000000;
      }
    }
  }
}
</style>
